import { graphql } from '__generated__';

import { MostQueriedResourceType } from '@/__generated__/graphql';
import { useQueryStable } from '@/hooks/useQueryStable';

// https://github.com/dbt-labs/codex-api/blob/main/schema.graphql
// https://github.com/dbt-labs/codex-api/blob/main/frontend/package.json#L33
// https://github.com/dbt-labs/codex-api/blob/main/frontend/codegen.yml
// generates: https://github.com/dbt-labs/codex-api/blob/main/frontend/src/typings/codex.ts
export const GetMostQueriedResources = graphql(/* GraphQL */ `
  query MostQueriedResources(
    $environmentId: BigInt!
    $end: Date!
    $start: Date!
    $resourceTypes: [MostQueriedResourceType!]!
    $limit: Int
  ) {
    performance(environmentId: $environmentId) {
      oldestQueryHistoryDate
      mostQueriedResources(
        end: $end
        start: $start
        resourceType: $resourceTypes
        limit: $limit
      ) {
        totalCount
        uniqueId
      }
    }
    environment(id: $environmentId) {
      modelQueryHistoryState {
        state
      }
    }
  }
`);

type MostQueriedResourcesParams = {
  environmentId: number | undefined;
  startDate: string;
  endDate: string;
  limit: number;
  resourceTypes: MostQueriedResourceType[];
  pause?: boolean;
};

export const useMostQueriedResources = ({
  environmentId = 0,
  startDate,
  endDate,
  resourceTypes,
  limit,
  pause,
}: MostQueriedResourcesParams) => {
  const query = useQueryStable({
    query: GetMostQueriedResources,
    variables: {
      environmentId,
      start: startDate,
      end: endDate,
      limit,
      resourceTypes,
    },
    pause:
      pause ||
      !environmentId ||
      !startDate ||
      !endDate ||
      !limit ||
      !resourceTypes.length,
  });

  // TODO: we need a cache invalidation strategy for performance endpoints

  return query;
};
